<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor de Tips Sala de Espera
    </div>
  </div>

  <div class="col-md-12">
    <br>
    <div class="sub-titulo">
      <span class="linea">
        Listado de Tips
      </span>

      <button type="button" class="btn btn-outline-primary botonListar" data-toggle="modal" data-target="#crearTips" >
        Agregar Tip
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div *ngIf="isLoading == false" class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Descripción</th>
          <th>Fecha de Creación</th>
          <th>Fecha de Vencimiento</th>
          <th>Estado</th>
          <th>Editar</th>
        </tr>
      </thead>
      <tbody style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngFor="let tips of tipsList">
          <td>{{tips.con_info_id}}</td>
          <td>{{tips.con_info_description}}</td>
          <td>{{tips.con_info_date_from}}</td>
          <td>{{tips.con_info_date_to}}</td>
          <td>{{tips.estado}}</td>
          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span data-toggle="modal" data-target="#visualizarTips" style="cursor: pointer;" (click)="clickTips(tips)">
                  <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      style="color: #316AD8;" aria-hidden="true" data-mat-icon-type="font">manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>   
      </tbody>
    </table>
  </div>

  <div *ngIf="isLoading" class="overlay-cargando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>


</div>

<!-- modal Visualizar/Editar-->
<div class="modal fade" id="visualizarTips" aria-labelledby="exampleModalLabel" aria-hidden="true"
    #visualizarTips>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="isEdit==false">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Visualizar Tips</p>
          <hr class="estiloHrModal">
          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Título:</strong> {{tipSelected.con_info_title}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Descripción:</strong> {{tipSelected.con_info_description}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha desde:</strong> {{tipSelected.con_info_date_from}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha hasta:</strong> {{tipSelected.con_info_date_to}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Habilitado:</strong> {{tipSelected.status}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Orden de aparición:</strong> {{tipSelected.con_info_priority}} </p>
            </div>
          </div>
        </div>

        <hr class="estiloHrModal">      
        <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
          <button type="button" class="primary buttonStyleSecondary" (click)="editTip()" >Editar</button>
        </div>

      </div>
    </div>

    <div class="modal-content" *ngIf="isEdit==true">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Editar Tips</p>
          <hr class="estiloHrModal">

          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                [(ngModel)]="tipSelected.con_info_title"
                [ngClass]="{'is-invalid': errores['con_info_title']}"
                class="form-control camposModalAgregar"
                placeholder="Título"
              />
              <div *ngIf="errores['con_info_title']" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <div class="col-6 mt-6">
              <p class="letraNormalModal"><strong>Orden de aparición:</strong></p>
              <select class="form-control" [(ngModel)]="tipSelected.con_info_priority">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
            </div>

            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                [(ngModel)]="tipSelected.con_info_description"
                [ngClass]="{'is-invalid': errores['con_info_description']}"
                class="form-control camposModalAgregar"
                placeholder="Descripción"
              ></textarea>
              <div *ngIf="errores['con_info_description']" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>

            <div class="col-4">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> </p>
              <input type="date" [(ngModel)]="tipSelected.con_info_date_from2" class="form-control" />
            </div>
            <div class="col-4">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> </p>
              <input type="date" [(ngModel)]="tipSelected.con_info_date_to2" class="form-control" />
            </div>

            <div class="col-4">
              <br>
              <div class="form-check">
                <input class="form-check-input"
                      type="checkbox"
                      id="tipsCheck"
                      [(ngModel)]="tipSelected.status">
                <label class="form-check-label" for="tipsCheck">
                  Habilitado
                </label>
              </div>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div style="display: flex; justify-content: center; align-items: center; gap: 15px; padding: 10px;">
            <button
              type="button"
              class="boton-accion colorLetraVolver"
              (click)="updateTip()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

            <button
              type="button"
              class="boton-accion colorLetraVolver"
              (click)="cancelEditTip()"
              [disabled]="isLoading"
            >
              Cancelar
            </button>

          </div>

        </div>
      </div>

      <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
        
    </div>
  </div>

</div>
<!-- modal Visualizar/Editar-->


<!-- modal Guardar-->
<div class="modal fade" id="crearTips" aria-labelledby="exampleModalLabel" aria-hidden="true"
    #crearTips>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" >
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Crear nuevo Tips</p>
          <hr class="estiloHrModal">
          <br>
          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="nuevoTip.titulo"
                [ngClass]="{'is-invalid': errores.titulo}"
              >
              <div *ngIf="errores.titulo" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <div class="col-6 mt-6">
              <p class="letraNormalModal"><strong>Orden de aparición:</strong></p>
              <select class="form-control" [(ngModel)]="nuevoTip.numero">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
            </div>

            <div class="col-9 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Descripción"
                [(ngModel)]="nuevoTip.descripcion"
                [ngClass]="{'is-invalid': errores.descripcion}"
                rows="3"
              ></textarea>
              <div *ngIf="errores.descripcion" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> </p>
              <input type="date" [(ngModel)]="nuevoTip.fechaFrom" class="form-control" />
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> </p>
              <input type="date" [(ngModel)]="nuevoTip.fechaTo" class="form-control" />
            </div>
          </div>
          <hr class="estiloHrModal">
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
            <button
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveTip()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>

</div>
<!-- modal Guardar-->